import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "./Title";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { LeaderboardContext } from "../providers/LeaderboardProvider";
import Grid from "@material-ui/core/Grid";
import { CircularProgress } from "@material-ui/core";

// Generate Order Data
function createData(id, rank, name, grade, score) {
  return { id, rank, name, grade, score };
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Leaderboard() {
  const users = Object.values(useContext(LeaderboardContext).users);
  users.sort(function (x, y) {
    return y.score - x.score;
  });
  let rows = [];
  let currScore = 1000000000;
  let currRank = 0;
  users.forEach((user, index) => {
    if (user.score < currScore) {
      currRank = index + 1;
      currScore = user.score;
    }
    rows.push(
      createData(index, currRank, user.username, user.grade, user.score)
    );
  });
  rows = rows.slice(0, 15);
  const classes = useStyles();
  const leaderboardState = useContext(LeaderboardContext);
  const challengesLoaded = leaderboardState.leaderboardLoaded;
  if (!challengesLoaded) {
    return (
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3} justify={"center"}>
          <CircularProgress />
        </Grid>
      </Container>
    );
  }
  return (
    <Container maxWidth="lg" className={classes.container}>
      <Paper className={classes.paper}>
        <React.Fragment>
          <Title>Leaderboard</Title>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Rank</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Grade</TableCell>
                <TableCell align="right">Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.rank}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.grade}</TableCell>
                  <TableCell align="right">{row.score}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div className={classes.seeMore}></div>
        </React.Fragment>
      </Paper>
    </Container>
  );
}
